module.exports = __webpack_public_path__ + "img/41606730.247bda27.png";